export const targetSeoMetadata = Object.freeze({
  sportNba: Object.freeze({
    path: '/sport/nba',
    title: 'Choose NBA Games to Watch Without Spoilers | skore.info',
    description:
      'Choose completed NBA games worth watching with scores hidden and spoiler-safe point-margin filters, then watch on your own replay platform.',
    canonical: 'https://skore.info/sport/nba',
    robots: 'index, follow',
  }),
  blogIndex: Object.freeze({
    path: '/blog',
    title: 'Spoiler-Free Sports Viewing Guides | skore.info',
    description:
      'Practical guides for choosing completed sports games without scores, headlines, thumbnails, or social spoilers, then watching on your own platform.',
    canonical: 'https://skore.info/blog',
    robots: 'index, follow',
  }),
  nbaRecapGuide: Object.freeze({
    path: '/blog/2025/03/23/nba-spoiler-free-recap',
    sourceTitle: 'Watch NBA Recaps Without Spoilers',
    title: 'Watch NBA Recaps Without Spoilers | skore.info Blog',
    description:
      'Use a spoiler-safe NBA recap workflow: hide scores, choose a completed game before opening score-first apps, then watch on your own replay service.',
    canonical: 'https://skore.info/blog/2025/03/23/nba-spoiler-free-recap',
    robots: 'index, follow',
  }),
});
